import { Box } from '@mui/material';
import { styled } from '@mui/system';

const LoginWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
}));

const AuthWrapper = styled(Box)(() => ({
  '& .amplify-tabs .amplify-tabs__list': {
    display: 'none'
  },
  '& .amplify-button--primary': {
    background: '#4285f4 !important',
    width: '50%',
    alignSelf: 'center'
  },
  // '& .amplify-divider': {
  //   display: 'none',
  // },
  '& [data-amplify-authenticator] [data-amplify-router]': {
    boxShadow: 'none',
    border: 'none',
  },
  // '& .amplify-button': {
  //   backgroundColor: 'white',
  // },
  // '& .amplify-flex:first-child': {
  //   padding: '0 !important',
  // },
  // '& .amplify-flex:last-child': {
  //   display: 'none',
  // },
  '& [data-amplify-footer]': {
    display: 'none',
  },
}));

const SignUpWrapper = styled(Box)(({ theme }) => ({
  padding: '0.5rem 2rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export { LoginWrapper, AuthWrapper, SignUpWrapper }
